const release = '0.13.9'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js